import { render, staticRenderFns } from "./VColorGroup.vue?vue&type=template&id=3b289ca2"
import script from "./VColorGroup.vue?vue&type=script&lang=js"
export * from "./VColorGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports